import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

interface NavigationHandlerProps {
  isAuthenticated: boolean;
  authLoading: boolean;
  showOrgSelector: boolean;
  hasOrganizations: number;
  organization: any;
}

const NavigationHandler: React.FC<NavigationHandlerProps> = ({
  isAuthenticated,
  authLoading,
  showOrgSelector,
  hasOrganizations,
  organization,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Don't handle navigation while auth is loading
    if (authLoading) return;

    // Only handle navigation if user is authenticated
    if (!isAuthenticated) return;

    // If user needs to select organization
    if (showOrgSelector && hasOrganizations > 1 && !organization) {
      if (location.pathname !== '/organization-select') {
        navigate('/organization-select', { replace: true });
      }
      return;
    }

    // If user has organizations but none selected, redirect to org selector
    if (hasOrganizations > 0 && !organization && !showOrgSelector) {
      if (location.pathname !== '/organization-select') {
        navigate('/organization-select', { replace: true });
      }
      return;
    }

    // If user is authenticated and has organization selected, redirect to home
    if (organization && location.pathname === '/auth') {
      navigate('/home', { replace: true });
      return;
    }

    // Default case: if authenticated and on auth page, go to home
    if (location.pathname === '/auth') {
      navigate('/home', { replace: true });
    }
  }, [
    authLoading,
    isAuthenticated,
    showOrgSelector,
    hasOrganizations,
    organization,
    navigate,
    location.pathname,
  ]);

  return null; // This component doesn't render anything
};

export default NavigationHandler;
